import React, { useState } from 'react';
import { FiCheck, FiX, FiAward } from 'react-icons/fi';
import { cn } from '@/lib/utils';

// Rounds rápidos de verdadeiro/falso: toca, vê feedback na hora, avança sozinho.
// statements: [{ text, answer: boolean }]
export function TrueFalseRapid({ statements }) {
  const [index, setIndex] = useState(0);
  const [answered, setAnswered] = useState(null); // { correct: boolean }
  const [correctCount, setCorrectCount] = useState(0);
  const [done, setDone] = useState(false);

  const statement = statements[index];

  const handleAnswer = value => {
    if (answered) return;
    const correct = value === statement.answer;
    setAnswered({ correct });
    if (correct) setCorrectCount(prev => prev + 1);

    setTimeout(() => {
      if (index + 1 < statements.length) {
        setIndex(prev => prev + 1);
        setAnswered(null);
      } else {
        setDone(true);
      }
    }, 900);
  };

  if (done) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-solid border-neutral-100 bg-white p-8 text-center shadow-card">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-lightest text-primary">
          <FiAward className="h-7 w-7" />
        </div>
        <h3 className="text-lg font-bold text-neutral-darker">Rodada concluída!</h3>
        <p className="text-sm text-neutral-500">
          Você acertou {correctCount}/{statements.length}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5 rounded-2xl border border-solid border-neutral-100 bg-white p-6 shadow-card">
      <div className="flex gap-1.5">
        {statements.map((_, i) => (
          <div
            key={i}
            className={cn('h-1.5 flex-1 rounded-full', i < index ? 'bg-primary' : i === index ? 'bg-primary-light' : 'bg-neutral-100')}
          />
        ))}
      </div>

      <p className="min-h-[72px] text-lg font-semibold leading-relaxed text-primary-dark">{statement.text}</p>

      {answered ? (
        <div className={cn('flex items-center gap-2 rounded-xl px-4 py-3 font-bold', answered.correct ? 'bg-success-lightest text-success' : 'bg-rose-50 text-rose-500')}>
          {answered.correct ? <FiCheck className="h-5 w-5 shrink-0" /> : <FiX className="h-5 w-5 shrink-0" />}
          {answered.correct ? 'Certo!' : `Errou — a resposta era "${statement.answer ? 'Verdadeiro' : 'Falso'}".`}
        </div>
      ) : (
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => handleAnswer(true)}
            className="flex-1 rounded-full bg-success py-4 font-bold text-white transition active:scale-[0.97]"
          >
            Verdadeiro
          </button>
          <button
            type="button"
            onClick={() => handleAnswer(false)}
            className="flex-1 rounded-full bg-rose-500 py-4 font-bold text-white transition active:scale-[0.97]"
          >
            Falso
          </button>
        </div>
      )}
    </div>
  );
}

export default TrueFalseRapid;
